import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SuperI } from 'src/app/modelos/superintendecia.interface';
import { TipoEntidadI } from 'src/app/modelos/tipoEntidad.interface';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-tipoentidad',
  templateUrl: './tipoentidad.component.html',
  styleUrls: ['./tipoentidad.component.css']
})
export class TipoentidadComponent implements OnInit {

  NuevatipoEnt : Boolean;
  TipoEntList : TipoEntidadI[];
  Superintendencias : SuperI[];
  TipoEntidadNue : TipoEntidadI;

  TipoEntEditar : TipoEntidadI;

  NuevaTipoEntSup : String;
  NuevaTipoEntCod = new FormControl({value:'', disabled: true},[Validators.required]);
  NuevaTipoEntNom = new FormControl({value:'', disabled: true},[Validators.required]);

  page : number;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.TipoEntidadNue = new TipoEntidadI;
    this.TipoEntEditar = new TipoEntidadI;
    this.NuevatipoEnt = false;
    /*this.api.getAllTipoEntidad().subscribe(data=>{
      this.TipoEntList = data;
      console.log(this.TipoEntList);
    });
    this.api.getAllSuper().subscribe(data2=>{
      this.Superintendencias = data2;
    });*/
  }

  Regresar(){
    this.router.navigate(['parametricas']);
  }

  NuevoTipoEntidad(){
    this.NuevatipoEnt = true;
    this.NuevaTipoEntCod.enable();
    this.NuevaTipoEntNom.enable();
  }

  Guardar(){
    if(this.NuevaTipoEntSup == '' || this.NuevaTipoEntSup == null){
      this.toastr.warning('Debe ingresar el codigo de Superintendencia.', 'Advertencia!');
      this.ngOnInit();
    } else if(this.NuevaTipoEntCod.value==''){
      this.toastr.warning('Debe ingresar el codigo de tipo de entidad.', 'Advertencia!');
      this.ngOnInit();
    } else if(this.NuevaTipoEntNom.value==''){
      this.toastr.warning('Debe ingresar el nombre de tipo de entidad.', 'Advertencia!');
      this.ngOnInit();
    } else {
      this.TipoEntidadNue.idSuper = this.NuevaTipoEntSup;
      this.TipoEntidadNue.codigo = this.NuevaTipoEntCod.value;
      this.TipoEntidadNue.nombre = this.NuevaTipoEntNom.value;
      /*this.api.nuevoTipoEntidad(this.TipoEntidadNue).subscribe(result1=>{
        if(result1){
          this.toastr.success('Tipo entidad creado.', 'OK!');
          this.ngOnInit();
        }
      }, error =>{
        this.toastr.error('Error al guardar.', 'Error!');
      });*/
    }
  }

  editarSuper(TipEnt){
    this.TipoEntEditar.id = TipEnt.id;
    this.TipoEntEditar.idSuper = TipEnt.idSuper;
    this.TipoEntEditar.codigo = TipEnt.codigo;
    this.TipoEntEditar.nombre = TipEnt.nombre;
  }

  guardarSuperEditada(){
    /*this.api.nuevoTipoEntidad(this.TipoEntEditar).subscribe(result2=>{
      if(result2){
        this.toastr.success('Tipo entidad editada.', 'OK!');
        this.ngOnInit();
      }
    }, error =>{
      this.toastr.error('Error al editar.', 'Error!');
    });*/
  }
}
